export function removeWWW(url: string | undefined) {
  return (url && url.split && url.split('www.')[1]) || url
}
